module.exports = __webpack_public_path__ + "static/media/Forklift.c361318d.png";